import * as React from "react";
const FlavoursAndFragranceSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M26 6a10.935 10.935 0 0 0-4.42.93c-1.887-3.172-4.99-4.75-5.132-4.824a1 1 0 0 0-.896 0c-.142.072-3.25 1.652-5.132 4.823A10.935 10.935 0 0 0 6 6.001a1 1 0 0 0-1 1v5a11.014 11.014 0 0 0 10 10.954v4.428l-4.553-2.277a1 1 0 1 0-.894 1.79l6 3a1 1 0 0 0 .895 0l6-3a1 1 0 1 0-.896-1.79L17 27.383v-4.428A11.013 11.013 0 0 0 27 12V7a1 1 0 0 0-1-1ZM15 20.947A9.012 9.012 0 0 1 7 12V8.056A9.013 9.013 0 0 1 15 17v3.945Zm1-8.525a11.05 11.05 0 0 0-3.83-4.522c1.196-1.973 3-3.237 3.83-3.75.831.51 2.635 1.774 3.83 3.75A11.058 11.058 0 0 0 16 12.421Zm9-.42a9.013 9.013 0 0 1-8 8.945V17a9.013 9.013 0 0 1 8-8.945V12Z"
    />
  </svg>
);
export default FlavoursAndFragranceSVG;
